const childData = {
  uuid: 'edc1194d-8b1f-4eb8-b808-fdc39772cbee',
  gender: 'male',
  lastName: 'Péťa',
  firstName: 'A.',
  birthDate: '2021-9-14'
};

export default childData;
